import ListSalesInvoices from "../../../../components/@documents/sales_invoices/ListSalesInvoices";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesInvoicesPage() {

    return (
        <ListSalesInvoices 
            routeType={routeTypes.admin}
        />
    )
}